import React, { useEffect, useState } from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import api from '../services/api'

/** Keep historical stage bookmarks working while emitting one UUID address. */
export default function CanonicalEntityRoute({ children }) {
  const { id } = useParams()
  const location = useLocation()
  const [address, setAddress] = useState(null)
  useEffect(() => {
    let cancelled = false
    setAddress(null)
    api.get(`/company/stages/${encodeURIComponent(id)}/address`)
      .then(response => { if (!cancelled) setAddress({ id, publicId: response.data.public_id }) })
      .catch(() => { if (!cancelled) setAddress({ id, publicId: id }) })
    return () => { cancelled = true }
  }, [id])
  if (!address || address.id !== id) return <div className="loading">Загрузка...</div>
  if (address.publicId && address.publicId !== id) {
    const parts = location.pathname.split('/')
    const index = parts[1] === 'stage' ? 2 : parts.indexOf('stages') + 1
    parts[index] = address.publicId
    return <Navigate to={parts.join('/') + location.search + location.hash} replace state={location.state} />
  }
  return children
}
